// extracted by mini-css-extract-plugin
export default {"downloadFilesContainer":"styles_downloadFilesContainer__fkQDS","fileContainer":"styles_fileContainer__zp7gY","download":"styles_download__0qHF7"};